<form
  [formGroup]="form"
  NfFormValidation
  (validSubmit)="onSubmit()"
  data-cy="form"
>
  <div class="modal-header" hsDraggable="modal-dialog">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      nf-icon-button="cancel"
      icon="close"
      class="btn-bare"
      ngbTooltip="Close"
      (click)="onCancel()"
    ></button>
  </div>
  <div class="modal-body" hsDraggable="modal-dialog">
    <div class="field-row">
      <nf-form-control *ngIf="actionCodes.length > 0" label="Action" compact>
        <ng-select
          id="action"
          name="action"
          [items]="actionCodes"
          placeholder="Select Action"
          formControlName="action"
          [closeOnSelect]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item
            }}<span
              *ngIf="notesRequiredActionCodeSet.has(item)"
              class="notes-required-diamond"
            >
              ◆</span
            >
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div [ngbTooltip]="item" container="body" class="ellipsis">
              {{ item
              }}<span
                *ngIf="notesRequiredActionCodeSet.has(item)"
                class="notes-required-diamond"
              >
                ◆</span
              >
            </div>
          </ng-template>
        </ng-select>
      </nf-form-control>
      <nf-form-control
        *ngIf="descriptionCodes.length > 0"
        label="Description"
        compact
      >
        <ng-select
          id="description"
          name="description"
          placeholder="Select Description"
          [items]="descriptionCodes"
          formControlName="description"
          [closeOnSelect]="true"
        >
          <ng-template ng-option-tmp let-item="item">
            <div [ngbTooltip]="item" container="body" class="ellipsis">
              {{ item }}
            </div>
          </ng-template>
        </ng-select>
      </nf-form-control>
      <button
        nf-icon-button="secondary"
        icon="content-paste"
        class="btn-bare paste-break-codes-btn"
        type="button"
        data-cy="paste-break-codes"
        [disabled]="!canPaste"
        ngbTooltip="Paste Break Codes (Alt+V)"
        (click)="onPasteBreakCodes()"
      ></button>
    </div>
    <div *ngFor="let hint of staleCodeHints" class="restricted-break-msg">
      {{ hint }}
    </div>
    <hs-note-editor
      #noteEditor
      [breaks]="breaks"
      [noteRequired]="validation.noteRequired"
      [collapsibleOptionalNote]="breaks.length === 1"
      [showNoteHandlingToggle]="breaks.length > 1"
      (noteChange)="onNoteChange($event)"
      (noteHandling)="onNoteHandlingChange($event)"
      (formReady)="onNoteEditorFormReady($event)"
    ></hs-note-editor>
    <hs-break-history
      *ngIf="breakIds.length === 1"
      [breakId]="breakIds[0]"
    ></hs-break-history>
  </div>
  <div class="modal-footer" hsDraggable="modal-dialog">
    <span *ngIf="restrictedBreaks.length > 0" class="restricted-break-msg">
      This is a restricted action that requires approval. Once submitted, the
      pending commands will be found on the Approvals panel for review.
    </span>
    <button nf-button="cancel" (click)="onCancel()"></button>
    <span
      [ngbTooltip]="validation.submitDisabled ? validation.reasons[0] : ''"
      container="body"
      class="d-inline-block"
    >
      <button
        nf-button="submit"
        [loading]="formSubmitting"
        [disabled]="form.invalid || validation.submitDisabled || formSubmitting"
      >
        {{ saveBtnLabel }}
      </button>
    </span>
  </div>
</form>
